import moment from 'moment';
import { cloneDeep } from 'lodash';
import { initSnackbar, initAccessProfiles, initWorkplanWarnings } from './initValues';
import { formatWorkplans } from './index.service';

const httpOptionReducer = () => {
    return {
        headers: {
            Authorization: process.env.REACT_APP_BASIC_AUTH,
            AuthToken: JSON.stringify({
                accessToken: localStorage.getItem('accessToken'),
                username: sessionStorage.getItem('username')
            })
        }
    }
}

const startDateReducer = (startDate = moment().startOf('year').format('YYYY-MM-DD'), action) => {
    if (action.type === 'UPDATE_STARTDATE') {
        return Object.assign({}, action.payload)
    }
    return startDate;
}

const endDateReducer = (endDate = moment().endOf('year').format('YYYY-MM-DD'), action) => {
    if (action.type === 'UPDATE_END_STARTDATE') {
        return Object.assign({}, action.payload)
    }
    return endDate;
}

// const workPlansReducer = (workPlans = [], action) => {
//     switch (action.type) {
//         case 'UPDATE_MAIN_WORKPLANS':
//             return Object.assign([], formatWorkplans(cloneDeep(action.payload)))
//         case 'CREATE_WORKPLAN':
//             return [...workPlans, action.payload]
//         default:
//             return workPlans;
//     }
// }

const MAINworkPlansReducer = (MAINworkPlans = [], action) => {
    switch (action.type) {
        case 'UPDATE_MAIN_WORKPLANS':
            return Object.assign([], formatWorkplans(cloneDeep(action.payload)));
        default:
            return MAINworkPlans;
    }
}

const employeesReducer = (employees = [], action) => {
    if (action.type === 'UPDATE_EMPLOYEES') {
        return Object.assign([], action.payload)
    }
    return employees;
}

const daysWeeksReducer = (daysWeeks = [], action) => {
    if (action.type === 'UPDATE_DAYS_WEEKS') {
        return Object.assign([], action.payload)
    }
    return daysWeeks;
}

const spinnerShowReducer = (spinnerShow = false, action) => {
    switch (action.type) {
        case 'UPDATE_SPINNER_SHOW':
            return action.payload;
        case 'UPDATE_CREATE_NEW_WORKPLAN':
        case 'UPDATE_MAIN_WORKPLANS':
        case 'CREATE_WORKPLAN':
        case 'UPDATE_SELECTED_WORKPLAN':
        case 'UPDATE_SNACKBAR':
        case 'GET_WORKPLAN_DETAILS':
        case 'UPDATE_SELECTED_PAYCODE_COLUMNS':
        case 'UPDATE_SIDE_PANEL_DATA':
        case 'UPDATE_SCHEDULE_PATTERN_TEMPLATES_DETAILS':
        case 'UPDATE_SHIFT_TEMPLATES_DETAILS':
            return false;
        default:
            return spinnerShow;
    }
}

const createNewWorkPlanReducer = (createNewWorkPlan = false, action) => {
    switch (action.type) {
        case 'UPDATE_CREATE_NEW_WORKPLAN':
            return action.payload
        case 'CREATE_WORKPLAN':
            return false
        default:
            return createNewWorkPlan;
    }
}

const snackbarReducer = (snackbar = initSnackbar, action) => {
    if (action.type === 'UPDATE_SNACKBAR') {
        return Object.assign({}, { ...snackbar, ...action.payload })
    }
    return snackbar;
}

const sidePanelDataReducer = (sidePanelData = {}, action) => {
    switch (action.type) {
        case 'UPDATE_SIDE_PANEL_DATA':
            return Object.assign({}, { ...sidePanelData, ...action.payload })
        case 'UPDATE_SELECTED_PAYCODE_COLUMNS_SIDE_PANEL':
            return Object.assign({}, { ...sidePanelData, ...action.payload.sidePanelData })
        default:
            return sidePanelData;
    }
}

const selectedWorkPlanReducer = (selectedWorkPlan = '', action) => {
    switch (action.type) {
        case 'UPDATE_SELECTED_WORKPLAN':
            return action.payload === '' ? '' : cloneDeep(action.payload)
        case 'UPDATE_MAIN_WORKPLANS':
            return '';
        case 'UPDATE_SELECT_ALL_SHIFT_LINES':
        case 'MANAGE_SHIFT_LINES':
        case 'GET_WORKPLAN_DETAILS':
            return action.payload.selectedWorkPlan === '' ? '' : cloneDeep(action.payload.selectedWorkPlan);
        case 'UPDATE_WORKPLAN_ASYNC_TASK_PROGRESS':
            return {
                ...selectedWorkPlan,
                ...action.payload,
            };
        default:
            return selectedWorkPlan;
    }
}

const selectedWorkPlanInitialReducer = (selectedWorkPlanInitial = '', action) => {
    switch (action.type) {
        case 'MANAGE_SHIFT_LINES':
            return action.payload.selectedWorkPlanInitial === '' ? '' : cloneDeep(action.payload.selectedWorkPlanInitial);
        default:
            return selectedWorkPlanInitial;
    }
}

const searchItemReducer = (searchItem = '', action) => {
    if (action.type === 'UPDATE_SEARCH_ITEM') {
        return action.payload
    }
    return searchItem;
}

const firstTimeReducer = (firstTime = true, action) => {
    if (action.type === 'UPDATE_FIRST_TIME') {
        return action.payload
    }
    return firstTime;
}

const searchValueReducer = (searchValue = '', action) => {
    if (action.type === 'UPDATE_SEARCH_VALUE') {
        return action.payload
    }
    return searchValue;
}

const orderByReducer = (orderBy = 'label', action) => {
    if (action.type === 'UPDATE_ORDER_BY') {
        return action.payload
    }
    return orderBy;
}

const orderReducer = (order = 'ASC', action) => {
    if (action.type === 'UPDATE_ORDER') {
        return action.payload
    }
    return order;
}

const filterReducer = (filter = '', action) => {
    if (action.type === 'UPDATE_FILTER') {
        return action.payload
    }
    return filter;
}

const filteredReducer = (filtered = false, action) => {
    if (action.type === 'UPDATE_FILTERED') {
        return action.payload
    }
    return filtered;
}

const filteredListReducer = (filteredList = [], action) => {
    if (action.type === 'UPDATE_FILTERED_LIST') {
        return Object.assign([], action.payload)
    }
    return filteredList;
}

const schedulePatternsTemplatesReducer = (schedulePatternsTemplates = [], action) => {
    if (action.type === 'UPDATE_SCHEDULE_PATTERN_TEMPLATES' || action.type === 'INIT_WORKPLAN_OBJECTS_LISTS') {
        return Object.assign([], action.payload.schedulePatternsTemplates)
    }
    return schedulePatternsTemplates;
}

const schedulePatternsTemplatesDetailsReducer = (schedulePatternsTemplatesDetails = [], action) => {
    if (action.type === 'UPDATE_SCHEDULE_PATTERN_TEMPLATES_DETAILS') {
        return Object.assign([], action.payload)
    }
    return schedulePatternsTemplatesDetails;
}

const shiftTemplatesDetailsReducer = (shiftTemplatesDetails = [], action) => {
    if (action.type === 'UPDATE_SHIFT_TEMPLATES_DETAILS') {
        return Object.assign([], action.payload);
    }
    return shiftTemplatesDetails;
}

const showRightPanelReducer = (showRightPanel = false, action) => {
    if (action.type === 'UPDATE_SHOW_RIGHT_PANEL') {
        return action.payload;
    }
    return showRightPanel;
}

const showRightPanelListReducer = (showRightPanelList = false, action) => {
    switch (action.type) {
        case 'UPDATE_SHOW_RIGHT_PANEL_LIST':
            return action.payload;
        case 'MANAGE_SHIFT_LINES':
            return false;
        default:
            break;
    }
    return showRightPanelList;
}
const actionWorkplanListReducer = (actionWorkplanList = false, action) => {
    if (action.type === 'UPDATE_ACTION_WORKPLAN_LIST') {
        return action.payload;
    }
    return actionWorkplanList;
}

const manageShiftLinesReducer = (manageShiftLines = false, action) => {
    switch (action.type) {
        case 'UPDATE_MANAGE_SHIFT_LINES':
            return action.payload;
        case 'MANAGE_SHIFT_LINES':
            return action.payload.manageShiftLines;
        default:
            break;
    }
    return manageShiftLines;
}

const showSidePanelReducer = (showSidePanel = false, action) => {
    switch (action.type) {
        case 'UPDATE_SHOW_SIDE_PANEL':
            return action.payload;
        case 'UPDATE_SIDE_PANEL_DATA':
        case 'UPDATE_SELECTED_PAYCODE_COLUMNS_SIDE_PANEL':
            return true;
        default:
            break;
    }
    return showSidePanel;
}

const paycodeListReducer = (paycodeList = [], action) => {
    if (action.type === 'UPDATE_PAYCODE_LIST' || action.type === 'INIT_WORKPLAN_OBJECTS_LISTS') {
        return Object.assign([], action.payload.payCodes)
    }
    return paycodeList;
}

const shiftTemplatesListReducer = (shiftTemplates = [], action) => {
    if (action.type === 'UPDATE_SHIFT_TEMPLATES_LIST' || action.type === 'INIT_WORKPLAN_OBJECTS_LISTS') {
        return Object.assign([], action.payload.shiftTemplates)
    }
    return shiftTemplates;
}

const selectedPaycodeReducer = (selectedPaycode = '', action) => {
    switch (action.type) {
        case 'UPDATE_SELECTED_PAYCODE':
            return action.payload === '' ? '' : Object.assign({}, action.payload)
        case 'MANAGE_SHIFT_LINES':
        case 'UPDATE_SELECTED_PAYCODE_COLUMNS':
        case 'UPDATE_SELECTED_PAYCODE_COLUMNS_SIDE_PANEL':
            return action.payload.selectedPaycode === '' ? '' : Object.assign({}, action.payload.selectedPaycode);
        default:
            return selectedPaycode;
    }
}

const employeeListReducer = (employeeList = [], action) => {
    switch (action.type) {
        case 'UPDATE_EMPLOYEE_LIST':
            return Object.assign([], action.payload)
        case 'INIT_WORKPLAN_OBJECTS_LISTS':
            return Object.assign([], action.payload.employeeList)
        default:
            return employeeList;
    }
}

const dataviewDataReducer = (dataviewData = [], action) => {
    switch (action.type) {
        case 'UPDATE_DATAVIEW_DATA':
            return Object.assign([], action.payload)
        case 'INIT_WORKPLAN_OBJECTS_LISTS':
            return Object.assign([], action.payload.dataviewData)
        default:
            return [...dataviewData];
    }
}

const dataviewColumnsReducer = (dataviewColumns = [], action) => {
    if (action.type === 'UPDATE_DATAVIEW_COLUMNS' || action.type === 'INIT_WORKPLAN_OBJECTS_LISTS') {
        return Object.assign([], action.payload.dataviewColumns)
    }
    return dataviewColumns;
}

const totalsColumnsReducer = (totalsColumns = [], action) => {
    if (action.type === 'UPDATE_TOTALS_COLUMNS') {
        return Object.assign([], action.payload.totalsColumns)
    }
    return totalsColumns;
}

const checkedAllReducer = (checkedAll = false, action) => {
    switch (action.type) {
        case 'UPDATE_SELECT_ALL':
            return action.payload;
        case 'UPDATE_SELECT_ALL_SHIFT_LINES':
            return action.payload.checkedAll;
        case 'INIT_WORKPLAN_OBJECTS_LISTS':
        case 'MANAGE_SHIFT_LINES':
            return false;
        default:
            return checkedAll;
    }
}

const tableColumnsReducer = (tableColumns = [], action) => {
    switch (action.type) {
        case 'UPDATE_TABLE_COLUMNS':
            return Object.assign([], action.payload);
        case 'UPDATE_SELECT_ALL_SHIFT_LINES':
        case 'MANAGE_SHIFT_LINES':
        case 'GET_WORKPLAN_DETAILS':
        case 'UPDATE_SELECTED_PAYCODE_COLUMNS':
        case 'UPDATE_SELECTED_PAYCODE_COLUMNS_SIDE_PANEL':
            return Object.assign([], action.payload.columns);
        default:
            break;
    }
    return tableColumns;
}

const urlKronosReducer = (urlKronos = '', action) => {
    if (action.type === 'UPDATE_SHOW_RIGHT_PANEL') {
        return action.payload;
    }
    return urlKronos;
}

const settingsListReducer = (settingsList = [], action) => {
    switch (action.type) {
        case 'UPDATE_SETTINGS_LIST':
            return Object.assign([], action.payload);
        default:
            break;
    }
    return settingsList;
}

const addShiftLineMenu = (isAddShiftLineMenuOpen = false, action) => {
    switch (action.type) {
        case 'UPDATE_TABLE_COLUMNS':
            return false
        case 'UPDATE_IS_SHIFT_LINE_MENU_OPEN':
            return action.payload
        default:
            return isAddShiftLineMenuOpen
    }
}

const accessProfilesReducer = (accessProfiles = initAccessProfiles, action) => {
    switch (action.type) {
        case 'GET_WORKPLAN_DETAILS':
            return action.payload.selectedWorkPlan === '' ? '' : cloneDeep(action.payload.accessProfiles);
        default:
            return accessProfiles;
    }
}

const skillAndCertificationProfilesReducer = (skillAndCertificationProfiles = [], action) => {
    if (action.type === 'INIT_WORKPLAN_OBJECTS_LISTS') {
        return Object.assign([], action.payload.skillAndCertificationProfiles)
    }
    return skillAndCertificationProfiles;
}

const warningsReducer = (warnings = initWorkplanWarnings, action) => {
    switch (action.type) {
        case 'UPDATE_WORKPLAN_WARNINGS':
            return {
                ...warnings,
                ...action.payload,
                isLoading: false,
            };
        case 'SET_WARNINGS_TO_LOADING':
            return {
                ...warnings,
                isLoading: true,
            }
        default:
            return warnings;
    }
}

function customCombinedReducer(state = {}, action) {
    return {
        startDate: startDateReducer(state.startDate, action),
        endDate: endDateReducer(state.endDate, action),
        MAINworkPlans: MAINworkPlansReducer(state.MAINworkPlans, action),
        employees: employeesReducer(state.employees, action),
        daysWeeks: daysWeeksReducer(state.daysWeeks, action),
        spinnerShow: spinnerShowReducer(state.spinnerShow, action),
        createNewWorkPlan: createNewWorkPlanReducer(state.createNewWorkPlan, action),
        selectedWorkPlan: selectedWorkPlanReducer(state.selectedWorkPlan, action),
        selectedWorkPlanInitial: selectedWorkPlanInitialReducer(state.selectedWorkPlanInitial, action),
        searchItem: searchItemReducer(state.searchItem, action),
        firstTime: firstTimeReducer(state.firstTime, action),
        searchValue: searchValueReducer(state.searchValue, action),
        orderBy: orderByReducer(state.orderBy, action),
        order: orderReducer(state.order, action),
        filter: filterReducer(state.filter, action),
        filtered: filteredReducer(state.filtered, action),
        filteredList: filteredListReducer(state.filteredList, action),
        schedulePatternsTemplates: schedulePatternsTemplatesReducer(state.schedulePatternsTemplates, action),
        schedulePatternsTemplatesDetails: schedulePatternsTemplatesDetailsReducer(state.schedulePatternsTemplatesDetails, action),
        shiftTemplatesDetails: shiftTemplatesDetailsReducer(state.shiftTemplatesDetails, action),
        showRightPanel: showRightPanelReducer(state.showRightPanel, action),
        showRightPanelList: showRightPanelListReducer(state.showRightPanelList, action),
        actionWorkplanList: actionWorkplanListReducer(state.actionWorkplanList, action),
        manageShiftLines: manageShiftLinesReducer(state.manageShiftLines, action),
        showSidePanel: showSidePanelReducer(state.showSidePanel, action),
        snackbar: snackbarReducer(state.snackbar, action),
        paycodeList: paycodeListReducer(state.paycodeList, action),
        shiftTemplatesList: shiftTemplatesListReducer(state.shiftTemplatesList, action),
        selectedPaycode: selectedPaycodeReducer(state.selectedPaycode, action),
        sidePanelData: sidePanelDataReducer(state.sidePanelData, action),
        employeeList: employeeListReducer(state.employeeList, action),
        dataviewData: dataviewDataReducer(state.dataviewData, action),
        dataviewColumns: dataviewColumnsReducer(state.dataviewColumns, action),
        totalsColumns: totalsColumnsReducer(state.totalsColumns, action),
        tableColumns: tableColumnsReducer(state.tableColumns, action),
        urlKronos: urlKronosReducer(state.urlKronos, action),
        checkedAll: checkedAllReducer(state.checkedAll, action),
        settingsList: settingsListReducer(state.settingsList, action),
        httpOptions: httpOptionReducer(),
        isAddShiftLineMenuOpen: addShiftLineMenu(state.isAddShiftLineMenuOpen, action),
        accessProfiles: accessProfilesReducer(state.accessProfiles, action),
        skillAndCertificationProfiles: skillAndCertificationProfilesReducer(state.skillAndCertificationProfiles, action),
        warnings: warningsReducer(state.warnings, action),
    };
}

export default customCombinedReducer;